import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {RetailLocationMicroStoreWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/retailLocationMicroStoreWorkspaceCapability/domain/RetailLocationMicroStoreWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type RetailLocationMicroStoreWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.retailLocationMicroStore> & {
    fixedUdoTemplates: {
        [RetailLocationMicroStoreWorkspaceCapabilityUdoTemplateKey.microStore]: {
            udoAdditionalColumnIds: {
                retailLocationId: Uuid;
                slug: Uuid;
                status: Uuid;
            };
        };
        [RetailLocationMicroStoreWorkspaceCapabilityUdoTemplateKey.page]: {
            udoAdditionalColumnIds: {
                pageStatus: Uuid;
                retailLocationMicroStoreId: Uuid;
                rootWidget: Uuid;
                slug: Uuid;
                uniqueKey: Uuid;
            };
        };
        [RetailLocationMicroStoreWorkspaceCapabilityUdoTemplateKey.defaultPage]: {
            udoAdditionalColumnIds: {
                pageStatus: Uuid;
                retailLocationTemplateId: Uuid;
                rootWidget: Uuid;
                slug: Uuid;
                uniqueKey: Uuid;
            };
        };
    };
};

export const retailLocationMicroStoreWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [RetailLocationMicroStoreWorkspaceCapabilityUdoTemplateKey.microStore]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({
                status: uuidZodValidator,
                retailLocationId: uuidZodValidator,
                slug: uuidZodValidator,
            }),
            udoTemplateId: uuidZodValidator,
        }),
        [RetailLocationMicroStoreWorkspaceCapabilityUdoTemplateKey.page]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({
                retailLocationMicroStoreId: uuidZodValidator,
                rootWidget: uuidZodValidator,
                slug: uuidZodValidator,
                pageStatus: uuidZodValidator,
                uniqueKey: uuidZodValidator,
            }),
            udoTemplateId: uuidZodValidator,
        }),
        [RetailLocationMicroStoreWorkspaceCapabilityUdoTemplateKey.defaultPage]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({
                retailLocationTemplateId: uuidZodValidator,
                rootWidget: uuidZodValidator,
                slug: uuidZodValidator,
                pageStatus: uuidZodValidator,
                uniqueKey: uuidZodValidator,
            }),
            udoTemplateId: uuidZodValidator,
        }),
    }),
}) satisfies zod.ZodType<RetailLocationMicroStoreWorkspaceCapabilityUdoBindings>;
